const PARAGRAPH_FOOTER_MENU = () => `
	menu(name: "footer") {
		items {
			title
			targetBlank
      disabled
			url {
				path
			}
		}
}`;

export default PARAGRAPH_FOOTER_MENU;
